import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";

// Each language's own name, in itself — never translated (a German label
// for "Arabic" doesn't help someone who can't read German), matching the
// convention almost every app's own language switcher follows.
const NATIVE_NAMES = { en: "English", de: "Deutsch", ar: "العربية" };

export default function LanguageSwitcher({ className }) {
  const { t, i18n } = useTranslation();
  return (
    <select
      className={className}
      aria-label={t("sidebar.language")}
      title={t("sidebar.language")}
      value={i18n.resolvedLanguage || i18n.language}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
    >
      {SUPPORTED_LANGUAGES.map((code) => (
        <option key={code} value={code}>
          {NATIVE_NAMES[code]}
        </option>
      ))}
    </select>
  );
}
